import React from "react";

const Soilbased_precision_farming = ({ asPerIndustry }) => {
  let serial = 1;
  return (
    <div style={{ pageBreakInside: "avoid" }}>
      <h3 style={{ marginTop: "40px" }}>
        Soil Based Precision Farming System:
      </h3>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "5%" }}>Sr.</th>
            <th style={{ width: "30%" }}>Item</th>
            <th>Description / Specification</th>
          </tr>
        </thead>
        <tbody>
          {asPerIndustry?.includes("bed_preparation") && (
            <tr>
              <td>{serial++}</td>
              <td>Bed Preparation</td>
              <td>
                Formation of raised soil beds with proper leveling and alignment
                to ensure efficient drainage, root aeration, and optimal plant
                growth within naturally ventilated polyhouse conditions.
              </td>
            </tr>
          )}
          {asPerIndustry?.includes("mulching_sheet_installation") && (
            <tr>
              <td>{serial++}</td>
              <td>Mulching Sheet Installation</td>
              <td>
                Installation of UV-stabilized plastic mulch sheet to control
                weeds, conserve soil moisture, regulate soil temperature, and
                improve crop yield and quality.
              </td>
            </tr>
          )}
          {asPerIndustry?.includes("drip_system") && (
            <>
              <tr>
                <td>{serial++}</td>
                <td>In line Drip Irrigation System</td>
                <td>
                  Supply and installation of inline drip irrigation system with
                  evenly spaced emitters for precise water and nutrient delivery
                  directly to plant root zones, ensuring water efficiency.
                </td>
              </tr>
              <tr>
                <td>{serial++}</td>
                <td>Drip Irrigation Plumbing Work Included</td>
                <td>
                  Complete plumbing network including mainline, sub-main,
                  valves, filters, and fittings for smooth and uniform water
                  distribution across the entire polyhouse area.
                </td>
              </tr>
            </>
          )}
          {asPerIndustry?.includes("trellising_installation") && (
            <tr>
              <td>{serial++}</td>
              <td>
                Trellising Installation (GI Wire Rope, Monofilament Wire, UV
                Treated Threads with Hooks and Plant Clips)
              </td>
              <td>
                Installation of durable trellising support system using GI wire
                ropes, monofilament wires, and UV-treated threads with hooks and
                plant clips to support vertical crop growth, improve air
                circulation, and maximize yield.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Soilbased_precision_farming;
